import { assetUrl } from '../../../../single-spa/asset-url';
import { ICapacityResponse, Capacity } from './../models/capacity.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import {environment} from './util.service';
import { IResponse } from '@signal/asp-data-commons';
import { IOverrideCapacity } from '@signal/asp-data-commons/lib/interfaces/availability';
import { Store } from '@ngrx/store';
import { DealerState } from '../../store/dealer/dealer.reducer';
import { selectDealerCode } from '../../store/dealer/dealer.selectors';

@Injectable({
    providedIn: 'root'
})
export class CapacityService {
    private apiRoot: string;

    constructor(private readonly http: HttpClient,private readonly dealerState: Store<DealerState>) {
        this.apiRoot = environment.aspAvailabilityApi;
    }

    getCapacity(): Observable<ICapacityResponse> {
        return this.http.get(assetUrl(`data/capacity.json`)).pipe(
            map((data: ICapacityResponse) => {
                return data;
            })
        )
    }

    getCapacityOverrideForDate(date: string, department: string): Observable<IResponse<IOverrideCapacity>> {
        return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
            return this.http.get(`${(this.apiRoot)}slots/${dealerCode}/${department}/capacity-override/${date}`).pipe(
              map((data: IResponse<IOverrideCapacity>) => {
                return data;
              }
              )
            );
          }));
    }

    updateCapacityOverrideForDate(department: string, capacityData: IOverrideCapacity): Observable<IResponse<IOverrideCapacity>> {
        return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
            return this.http.post(`${(this.apiRoot)}slots/${dealerCode}/${department}/capacity-override`, capacityData).pipe(
              map((data: IResponse<IOverrideCapacity>) => {
                return data;
              }
              )
            );
          }));
    }


    updateCapacity(capacity: Capacity): Observable<Capacity> {
        return this.http.get(assetUrl(`data/capacity.json`)).pipe(
            map((data: Capacity) => {
                return capacity;
            })
        )
    }

}
